import { userService } from '../_services';
import {isUserOnline, router} from '../_helpers';

const user = JSON.parse(localStorage.getItem('user'));
const state = user
    ? { status: { loggedIn: true }, user }
    : { status: {}, user: null };

const actions = {
    login({ dispatch, commit }, { username, password }) {
        commit('loginRequest', { username });

        userService.login(username, password)
            .then(
                user => {
                    commit('loginSuccess', user);
                    router.push('/');
                },
                error => {
                    commit('loginFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    logout({ commit }) {
        userService.logout();
        commit('logout');
    },
    register({ dispatch, commit }, user) {
        commit('registerRequest', user);

        userService.register(user)
            .then(
                user => {
                    commit('registerSuccess', user);
                    router.push('/login');
                    setTimeout(() => {
                        // display success message after route change completes
                        dispatch('alert/success', 'Registration successful', { root: true });
                    })
                },
                error => {
                    commit('registerFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    updateUserInfo({ dispatch, commit }, userData = null){
        if (userData == null){
            userData = user;
        }

        if(isUserOnline()){
            // Call userService update API call
            userService.update(userData)
                .then(
                    userData => {
                        commit('updateSuccess', userData);
                    },
                    error => {
                        commit('updateFailure', error);
                        dispatch('alert/error', error, { root: true });
                    }
                )
        } else {
            // Cache answer
            // Get cache data
            var offlineData = [];
            if(localStorage.getItem('offlineData')){
                offlineData = JSON.parse(localStorage.getItem('offlineData'));
            }

            console.log(offlineData);

            // Create json object
            var dataObject = {
                "service":"userService",
                "operation":"update",
                "dataObject": [
                    {
                        "user": user
                    }
                ]
            };

            // Append json object to JSON data
            offlineData.push(dataObject);
            console.log(JSON.stringify(offlineData));

            localStorage.setItem('offlineData', JSON.stringify(offlineData));
        }
    }
};

const mutations = {
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.user = user;
    },
    loginSuccess(state, user) {
        state.status = { loggedIn: true };
        state.user = user;
    },
    loginFailure(state) {
        state.status = {};
        state.user = null;
    },
    updateFirstName(state, firstName) {
        state.status = {};
        state.user.firstName = firstName;
    },
    updateLastName(state, lastName) {
        state.status = {};
        state.user.lastName = lastName;
    },
    updateRequest(state, user) {
        // Change state
        state.status = {};
    },
    updateSuccess(state, user) {
        state.status = {};
    },
    updateFailure(state, error) {
        state.status = {};
    },
    logout(state) {
        state.status = {};
        state.user = null;
    },
    registerRequest(state, user) {
        state.status = { registering: true };
    },
    registerSuccess(state, user) {
        state.status = {};
    },
    registerFailure(state, error) {
        state.status = {};
    }
};

export const account = {
    namespaced: true,
    state,
    actions,
    mutations
};
